import React, { Component } from 'react';
import ErrorBoundary from "../../components/AppError/errorBoundary";
import  CKEditor from './ckeditorfile';
class CKTextEditor extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this)
    }

    onChange(e){
        var data = e.editor ? e.editor.getData() : e.sender.editor.getData();
        this.props.onChange(data)
    }

    render() {
        return (
                <ErrorBoundary>
            <div className={this.props.class}>
            <CKEditor
                data={this.props.editorData}
                onChange={this.onChange}
                onContentDom={(e) => {
                    let editable = e.editor.editable();
                    editable.$.parentElement.style.height = "88%";
                    editable.$.style.height = "88%";

                    editable.attachListener(editable, 'input', (e) => {
                        if(e.data.$.inputType == "insertReplacementText") {
                            this.onChange(e)
                        }
                    })
                }}
                onBeforeLoad={(CKEDITOR) => {
                    if (CKEDITOR) CKEDITOR.disableAutoInline = true
                }}
                config={ {
                    toolbar : [
                        ...(this.props.richToolbar ? [{ name: 'fonts', items: ['Font', 'FontSize'] }] : []),
                        { name: 'clipboard', items: ['Cut', 'Copy', '-', 'Undo', 'Redo'] },
                        { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'RemoveFormat'] },
                        { name: 'styles', items: ['Format'] },
                       // { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
                        { name: 'paragraph', items: this.props.richToolbar ? ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'] : ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote' ] },
                        { name: 'links', items: ['Link', 'Unlink'] },
                        { name: 'insert', items: ['Table', 'HorizontalRule', 'SpecialChar'] },
                        //{ name: 'tools', items: ['Maximize'] }
                    ],
                    extraPlugins:'indentblock',
                    removeButtons: 'Subscript,Superscript',
                    allowedContent : true,
                    removePlugins: 'elementspath,contextmenu,liststyle,tabletools,tableselection,magicline' + (this.props.hideBorders ? ',showborders' : ''),
                    disableNativeSpellChecker : false,
                    resize_enabled: this.props.disableResize ? false : true,
                    ...(this.props.height ? { height: this.props.height } : {})
                } }
            />
            </div>
            </ErrorBoundary>
        );
    }
}

export default CKTextEditor;